import { inject, Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

// Configurar las fuentes de pdfMake
(pdfMake as any).vfs = (pdfFonts as any).pdfMake?.vfs || pdfFonts;


import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class PdfService {

  constructor(
    private datepipe: DatePipe,
    ) {
   }
  private spinner = inject(NgxSpinnerService);

  async createPDF(load:any){ 
    let logo: string | null = null;
    try {
      logo = await this.getBase64FromUrl('assets/AM Servicios_White.png');
    } catch (error) {
      console.warn('No se pudo cargar el logo para el PDF, se genera sin él.', error);
    }

    const fotoDataUrl = await this.resolveImageDataUrl(load['pathFoto']);

    const logoCell: any = logo
      ? { image: logo, width: 180, height: 145 }
      : { text: '', width: 180 };

    const fotoCell: any = fotoDataUrl
      ? { image: fotoDataUrl, width: 225, height: 185 }
      : { text: '\n\nSin imagen disponible', italics: true, fontSize: 12, alignment: 'center' };

    var dd = {
      pageOrientation:'landscape',
      content: [
        {                   
          columns: [
            logoCell,
            {text: `Folio  ${load.cargaEstacion} \n\nFecha: ${this.datepipe.transform(load.fechaCreacion, 'dd/MM/yy')} \nHora: ${this.datepipe.transform(load.fechaCreacion, 'hh:mm aa')}`, bold:true, fontSize: 14,alignment:'right'}
          ]
        },
        { text:'Comprobante de Carga de Combustible.\n', bold:true, fontSize: 18,alignment:'center'},
        '\n\n\n',
        {
           columns: [           
    {text: `\nDescripción: \n ${load.descripcion} \n\n\n Almacen/Tipo: \n ${load.almacen}-${load.combustibleCargado} \n\n\n Transacción Máximo: \n ${load.transaccionMaximo}`, bold:true, fontSize: 14,alignment:'center'},
    fotoCell,
    {text: `\nNúmero Económico: \n ${load.numeroActivo} \n\n\n Litros Cargados: \n ${load.litrosCarga} \n\n\n Horómetro: \n ${load.horometro}`, bold:true, fontSize: 14,alignment:'center'}
  ]            
},
        '\n\n\n',
       { 
         table: {          
          headerRows: 1,          
          widths: [ '*','*','*' ],
          body: [
            [ { text: 'Rol', bold: true,fontSize: 14,alignment:'center' },{ text:  'No. de Empleado', bold: true,fontSize: 14,alignment:'center' },{ text: 'Responsable', bold: true ,fontSize: 14,alignment:'center'}   ],
            [ {text:`Despachador`,alignment:'center'}, {text:`${load.numeroDespachador}`,alignment:'center'}, {text:`${load.nombreDespachador}`,alignment:'center'} ],
            [ {text:`Operador`,alignment:'center'}, {text:`${load.numeroOperador}`,alignment:'center'},{text:`${load.nombreOperador}`,alignment:'center'} ]
          ]       
        }
       }
     ]
    }        
    this.returnPDF(load.cargaEstacion,dd);
  }
 

  returnPDF(info:string, docDefinition: any){
    try {
      return pdfMake.createPdf(docDefinition).download('Comprobante'+info+'.pdf');
    } catch (error) {
      console.error('No se pudo generar el PDF:', error);
      return null;
    } finally {
      this.spinner.hide();
    }
  }

  /**
   * Normaliza el valor de pathFoto a un dataURL que pdfMake pueda usar.
   * Si la imagen no es utilizable devuelve null para que el PDF se genere sin ella
   * (en vez de romper toda la descarga con "Unknown image format").
   * - Vacío/null            -> null (se omite la imagen)
   * - data:image/...        -> se usa tal cual (ya viene como dataURL)
   * - URL (S3 prefirmada)   -> se descarga y se convierte a dataURL
   * - base64 crudo válido   -> se detecta el tipo (PNG/JPEG) y se antepone el prefijo data URI
   * - cualquier otra cosa   -> null
   */
  async resolveImageDataUrl(pathFoto: any): Promise<string | null> {
    if (!pathFoto) {
      return null;
    }

    const raw = String(pathFoto).trim();
    if (!raw) {
      return null;
    }

    // Ya es un dataURL de imagen completo.
    if (raw.startsWith('data:image/')) {
      return raw;
    }

    // URL (p. ej. URL prefirmada de S3): se descarga y se convierte a base64.
    // Importante: no se debe re-encodear la URL, los parámetros de la firma ya vienen escapados.
    if (/^https?:\/\//i.test(raw)) {
      try {
        return await this.fetchImageAsDataUrl(raw);
      } catch (error) {
        console.warn('No se pudo descargar la imagen desde la URL; se omite en el PDF.', error);
        return null;
      }
    }

    // A partir de aquí se asume base64 crudo: se quitan saltos de línea/espacios.
    const value = raw.replace(/\s/g, '');

    // Valida que realmente sea base64 (acepta también el alfabeto URL-safe).
    const isBase64 = value.length > 100 && /^[A-Za-z0-9+/_-]+={0,2}$/.test(value);
    if (!isBase64) {
      console.warn('pathFoto no es un base64 válido ni una URL; se omite la imagen en el PDF.');
      return null;
    }

    // Detecta el formato a partir de la firma del base64.
    const mime = value.startsWith('/9j/') ? 'image/jpeg' : 'image/png';
    return `data:${mime};base64,${value}`;
  }

  /**
   * Descarga una imagen por HTTP y la convierte a dataURL base64.
   * Requiere que el origen (bucket S3) responda con cabeceras CORS que permitan
   * el dominio de la aplicación; si no, el fetch fallará.
   */
  private async fetchImageAsDataUrl(url: string): Promise<string> {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`La descarga de la imagen devolvió HTTP ${response.status}`);
    }

    const blob = await response.blob();

    if (!blob.size) {
      throw new Error('La imagen descargada está vacía');
    }

    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        if (typeof result === 'string' && result.startsWith('data:image/')) {
          resolve(result);
        } else {
          reject(new Error('El contenido descargado no es una imagen válida'));
        }
      };
      reader.onerror = () => reject(reader.error ?? new Error('Error leyendo la imagen'));
      reader.readAsDataURL(blob);
    });
  }

  getBase64FromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
  
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
  
        var ctx = canvas.getContext("2d");
        ctx!.drawImage(img, 0, 0);
  
        var dataURL = canvas.toDataURL("image/png");
  
        resolve(dataURL);
      };
  
      img.onerror = error => {
        reject(error);
      };
  
      // Encode the URL so filenames with spaces (e.g. "AM Servicios_White.png") resolve correctly.
      img.src = encodeURI(url);
    });
  }
}
